import { slideMasters } from '@features/executive-report/utils/slide-masters';
import { themeV2 as theme } from '../../domain/theme-v2';
import {
  ShapeProps,
  Slide,
  TextPropsTextConfig,
  ZERO_WIDTH_SPACE,
} from '@features/powerpoint';

const BULLET_INDENT = 16;

const dividerLine = (options?: ShapeProps['options']): ShapeProps => ({
  shapeName: 'line',
  options: {
    line: {
      color: theme.colors.inmarketGreen,
      width: 1.5,
    },
    h: 4.2,
    w: 0,
    x: 0.49,
    y: 1.67,
    ...options,
  },
});

const objectiveListText = (text: string): TextPropsTextConfig[] => [
  {
    text: ZERO_WIDTH_SPACE,
    options: {
      bullet: { indent: BULLET_INDENT, type: 'number' },
      color: theme.colors.inmarketGreen,
      fontSize: 18,
      paraSpaceBefore: 12,
    },
  },
  {
    text,
    options: { color: theme.colors.white, fontSize: 18, paraSpaceBefore: 12 },
  },
];

const whatsInsideListText = (text: string): TextPropsTextConfig[] => [
  {
    text: ZERO_WIDTH_SPACE,
    options: {
      bullet: { indent: BULLET_INDENT },
      color: theme.colors.inmarketGreen,
      fontSize: 18,
      paraSpaceBefore: 12,
    },
  },
  {
    text,
    options: { color: theme.colors.white, fontSize: 18, paraSpaceBefore: 12 },
  },
];

const campaignPerformanceList = (
  title: string,
  text: string
): TextPropsTextConfig[] => [
  {
    text: title.toUpperCase(),
    options: {
      fontSize: 14,
      color: theme.colors.inmarketGreen,
      bullet: { indent: BULLET_INDENT },
      indentLevel: 2,
      bold: true,
      paraSpaceBefore: 12,
    },
  },
  {
    text,
    options: { fontSize: 14, color: theme.colors.white, paraSpaceBefore: 12 },
  },
];

export const agendaSlide = (
  campaignPerformanceItems: { title: string; text: string }[]
): Slide => {
  const campaignPerformanceTexts = campaignPerformanceItems.map(item =>
    campaignPerformanceList(item.title, item.text)
  );

  return {
    slideMaster: slideMasters.dark,
    texts: [
      {
        text: 'Agenda',
        options: {
          fill: {
            type: 'solid',
            color: theme.colors.metricBlue,
          },
          h: 0.75,
          w: 2.75,
          x: 0.33,
          y: 0.33,
          fontSize: 44,
          color: theme.colors.white,
          bold: true,
        },
      },
      {
        text: [
          {
            text: "Today's ",
            options: {
              fontSize: 32,
              color: theme.colors.white,
              bold: true,
            },
          },
          {
            text: 'Objective',
            options: {
              fontSize: 32,
              color: theme.colors.inmarketGreen,
              bold: true,
            },
          },
          ...objectiveListText('Discuss campaign outcomes'),
          ...objectiveListText('Quantify performance & optimizations'),
          ...objectiveListText('Share intelligence for future success'),
        ],
        options: {
          valign: 'top',
          h: 2.05,
          w: 5.62,
          x: 0.61,
          y: 1.66,
        },
      },
      {
        text: [
          {
            text: "What's ",
            options: {
              fontSize: 32,
              color: theme.colors.white,
              bold: true,
            },
          },
          {
            text: 'inside',
            options: {
              fontSize: 32,
              color: theme.colors.inmarketGreen,
              bold: true,
            },
          },
          ...whatsInsideListText('Introduction'),
          ...whatsInsideListText('Campaign Overview'),
          ...whatsInsideListText('Campaign Performance'),
          ...campaignPerformanceTexts.flat(),
          ...whatsInsideListText('Summary and Recommendations'),
          ...whatsInsideListText('Insights'),
        ],
        options: {
          valign: 'top',
          h: 4.21,
          w: 5.62,
          x: 6.86,
          y: 1.66,
        },
      },
    ],
    shapes: [dividerLine(), dividerLine({ x: 6.74 })],
  };
};
